import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class MessageModule {

  id: string;
  body: string;
  sala:string;
  usuario:string;
  mensaje:string;
  user:string;
  leer:string;
  leer_local:string;
  message:string;
  hora:string;
 }
